const GenerateReport = () => import("./views/GenerateReport.vue");
const AllReport = () => import("./views/AllReport.vue");

export default [
  {
    path: "generate",
    name: "generate-payroll-report",
    component: GenerateReport,
  },
  {
    path: "all",
    name: "payroll-view-report",
    component: AllReport,
  },
];
